import { EventEmitter, Injectable, Output } from "@angular/core";
import { MatDrawer } from "@angular/material/sidenav";
import { ActivatedRoute, ChildActivationEnd, Router } from "@angular/router";
import { BehaviorSubject, filter, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
export class SideBarService {

      @Output() change: EventEmitter<boolean> = new EventEmitter();
      @Output() changeMenuUser: EventEmitter<boolean> = new EventEmitter();
      
      toggle(): void {
          this.change.emit(true);
      }

      showMenuUser(): void {
        this.changeMenuUser.emit(true);
    }
      
}
